import QRCode from "react-qr-code";
import { Button } from "./ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "./ui/card";


const formatCountdown = (seconds) => {
  const safeSeconds = Math.max(0, Number(seconds || 0));
  const minutes = String(Math.floor(safeSeconds / 60)).padStart(2, "0");
  const remainingSeconds = String(safeSeconds % 60).padStart(2, "0");
  return `${minutes}:${remainingSeconds}`;
};


export const KioskSessionCard = ({ session, isOpening, onOpen }) => {
  const isExpired = session.expired || !session.active;

  return (
    <Card className="border-slate-200/70 bg-white/85" data-testid={`kiosk-session-card-${session.id}`}>
      <CardHeader className="space-y-3">
        <div className="flex items-start justify-between gap-3">
          <div>
            <CardTitle data-testid={`kiosk-session-title-${session.id}`}>{session.label}</CardTitle>
            <CardDescription data-testid={`kiosk-session-description-${session.id}`}>Session ends {session.session_ends_at ? new Date(session.session_ends_at).toLocaleString("en-IN") : "soon"}</CardDescription>
          </div>
          <span
            className={`inline-flex rounded-full px-3 py-1 text-xs font-semibold ${isExpired ? "bg-rose-100 text-rose-700" : "bg-emerald-100 text-emerald-700"}`}
            data-testid={`kiosk-session-state-${session.id}`}
          >
            {isExpired ? "Expired" : "Live"}
          </span>
        </div>
        <div className="grid gap-3 sm:grid-cols-2" data-testid={`kiosk-session-metrics-${session.id}`}>
          <div className="rounded-2xl border border-slate-200 bg-slate-50 p-3">
            <p className="text-xs font-semibold uppercase tracking-[0.22em] text-slate-400" data-testid={`kiosk-session-next-rotation-label-${session.id}`}>Next QR rotation</p>
            <p className="mt-2 text-2xl font-extrabold text-slate-900" data-testid={`kiosk-session-seconds-${session.id}`}>{formatCountdown(session.seconds_remaining)}</p>
          </div>
          <div className="rounded-2xl border border-slate-200 bg-slate-50 p-3">
            <p className="text-xs font-semibold uppercase tracking-[0.22em] text-slate-400" data-testid={`kiosk-session-window-count-label-${session.id}`}>Opened windows</p>
            <p className="mt-2 text-2xl font-extrabold text-slate-900" data-testid={`kiosk-session-window-count-${session.id}`}>{session.opened_window_count || 0}</p>
          </div>
        </div>
      </CardHeader>
      <CardContent className="space-y-4">
        {session.scan_url ? (
          <div className="rounded-3xl border border-slate-200 bg-white p-4" data-testid={`kiosk-session-qr-${session.id}`}>
            <QRCode value={session.scan_url} className="h-full w-full" />
          </div>
        ) : (
          <div className="rounded-3xl border border-dashed border-slate-200 bg-slate-50 p-10 text-center text-sm text-slate-400" data-testid={`kiosk-session-no-qr-${session.id}`}>
            QR unavailable because this session is no longer live.
          </div>
        )}
        <p className="text-sm text-slate-500" data-testid={`kiosk-session-rotation-copy-${session.id}`}>This QR refreshes in the live kiosk window every minute and stays valid only for the current short window.</p>
        <p className="break-all text-xs text-slate-500" data-testid={`kiosk-session-link-${session.id}`}>{session.scan_url || "No live scan link"}</p>
        <Button
          type="button"
          className="w-full rounded-2xl bg-[#0D1B2A] text-white hover:bg-[#08131F]"
          onClick={() => onOpen(session)}
          disabled={isOpening || isExpired}
          data-testid={`kiosk-session-open-button-${session.id}`}
        >
          {isOpening ? "Opening..." : "Open in new window"}
        </Button>
      </CardContent>
    </Card>
  );
};